export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'

export const MAX_DEPARTURE_DAY_WITHOUT_TODAY = 89
export const MULTI_TRIP_RETURN_DAY = 180
